<script setup lang="ts">
import { type OrganizationProviderType, EProviders } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import DevicesFilters from '../DeviceComponents/Table/Filters/DevicesFilters.vue'

provide<OrganizationProviderType>(EProviders.ORGANIZATION, {
    deviceTableFilters: DevicesFilters
})
</script>

<template>
    <slot />
</template>
